<template>
  <el-dialog
    title="费用异议"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="handleClose"
  >
    <el-form
      label-position="left"
      label-width="70px"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      v-if="!tableData.length"
    >
      <el-form-item label="内容" prop="title">
        <el-input
          type="textarea"
          placeholder="请输入内容"
          v-model="ruleForm.title"
          :max-rows="4"
        >
        </el-input>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          size="mini"
          style="margin-left: 10px"
          :loading="btnLoading"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
    <div class="tableBox">
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column type="index" label="序号" width="60" align="center">
        </el-table-column>
        <el-table-column prop="create_time" label="时间" width="100" align="center">
        </el-table-column>
        <el-table-column prop="content" label="内容" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="status" label="内容" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1" type="info" size="mini">已提交</el-tag>
            <el-tag v-if="scope.row.status == 2" type="warning" size="mini"
              >已审核</el-tag
            >
            <el-tag v-if="scope.row.status == 10" type="success" size="mini">已阅</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import * as https from "@/api/order.js";
export default {
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        title: "",
      },
      tableData: [],
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      rules: {
        title: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
      btnLoading: false,
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          let params = {
            student_id: this.userInfo.id,
            student_name: this.userInfo.student_name,
            content: this.ruleForm.title,
            type: 10,
            number: this.userInfo.number,
            company_id: localStorage.getItem("company_id"),
            grade_id: this.userInfo.grade_id,
          };
          https
            .insertOpinion({ ...params })
            .then((res) => {
              this.btnLoading = false;
              this.resetForm("ruleForm");
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.getList();
            })
            .catch((_) => {
              this.btnLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getList() {
      https.getNotice({ type: 10, student_id: this.userInfo.id }).then((res) => {
        this.tableData = res.data;
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    showDialog() {
      this.dialogVisible = true;
      this.getList();
    },
    handleClose() {
      this.dialogVisible = false;
      this.btnLoading = false;
      this.resetForm("ruleForm");
    },
  },
};
</script>
<style lang="scss" scoped>
.tableBox {
  margin-top: 20px;
}
::v-deep .el-form {
  padding: 0 !important;
  box-shadow: none !important;
}
::v-deep .el-form-item__label {
  font-size: 16px !important;
}
::v-deep .el-form-item {
  padding: 10px !important;
}
::v-deep .el-form-item__content {
  display: flex;
  align-items: baseline;
  width: 80%;
}
</style>
